define('views/modules/calendar/calendar/summary/summary',[
    // Libs
    'underscore',
    'backbone',
    'mustache',
    'utils',
    'moment',
    // events
    // Collections

    // views
    'views/modules/calendar/calendar/summary/summary-tables/summary-table',
    // Templates
    'text!templates/modules/calendar/calendar/summary/summary.html',
], function(
    // libs
    _, Backbone, Mustache, U, moment,
    // events
    // Collections and models

    // views
    VSummaryTable,
    // templates
    TSummary
) {

    var VSummary = Backbone.View.extend({
        template: TSummary,
        events: {

        },

        regions: {
            root: ".summary",
            activity: ".activity-table",
            average: ".average-table",
            total: ".total-table"
        },

        initialize: function(opt) {
            opt = opt || {};

            this.activityDataCollection = new Backbone.Collection([
                { name: 'activities:Weightlifting', count: 2 },
                { name: 'activities:Elliptic trainer', count: 3 }
            ]);

            this.averageDataCollection = new Backbone.Collection([
                { feedback: 'calendar:Great', effort: 2, duration: 25, calories: 300 },
                { feedback: 'calendar:Great', effort: 3, duration: 25, calories: 200 }
            ]);

            this.totalDataCollection = new Backbone.Collection([
                { distance: 75, duration: 25, calories: 400 },
                { distance: 3, duration: 25, calories: 200 }
            ]);

            this.view = {
                activity: new VSummaryTable({
                    model: this.model,
                    headers: ["Activity", "calendar:Count"],
                    rows: this.activityDataCollection,
                    type: "activity"
                }),

                average: new VSummaryTable({
                    model: this.model,
                    title: "calendar:Average Statistic",
                    headers: ["calendar:Feedback", "Effort", "Duration", "Calories"],
                    rows: this.averageDataCollection,
                    type: "average"
                }),

                total: new VSummaryTable({
                    model: this.model,
                    title: "calendar:Total Statistic",
                    headers: ["Distance", "Duration", "Calories"],
                    rows: this.totalDataCollection,
                    type: "total"
                })
            };
        },

        render: function() {

            // Render HTML template
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            // caching element into this.zone
            this.generateZones();
            this.assign(this.view.activity, this.zone.$activity);
            this.assign(this.view.average, this.zone.$average);
            this.assign(this.view.total, this.zone.$total);

            return this;
        },

    });

    return VSummary;

});

